import { createRoot } from 'react-dom/client';
import PublicRulesApp from './PublicRulesApp';
import './styles/public-rules.css';

const container = document.getElementById('fairplay-rules-public-rules');

if (container) {
	const root = createRoot(container);
	root.render(<PublicRulesApp />);
}